import React from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { ArrowLeft } from "lucide-react";

export function VolverAtras() {
  const navigate = useNavigate();
  useLocation();
  const puede = (window.history.state?.idx ?? 0) > 0;
  return (
    <button type="button" onClick={() => navigate(-1)} disabled={!puede} title="Volver a la pantalla anterior" data-testid="volver-atras-global"
            className="inline-flex items-center gap-1.5 px-3 py-2 rounded-lg border border-slate-200 bg-white text-sm font-semibold text-slate-700 hover:border-sky-400 hover:text-sky-800 disabled:opacity-40 disabled:pointer-events-none transition-colors shrink-0">
      <ArrowLeft size={15} /> <span className="hidden sm:inline">Volver</span>
    </button>
  );
}
